import './empty-state.scss';
import React, { ReactNode } from 'react';
import CustomIcon, { IconType } from '../custom-icon/custom-icon';

interface EmptyStateProps {
    iconType: IconType;
    title?: string;
    subTitle?: string;
    secondarySubTitle?: string;
    children?: ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({iconType, title, subTitle, secondarySubTitle, children}) => {
    return <div className="empty-state">
        <CustomIcon type={iconType} size={96} />
        <div className="empty-state-title">{title ?? 'Nothing here just yet... '}</div>
        <div className="empty-state-sub-title">
            {subTitle} <span>{secondarySubTitle}</span>
        </div>
        {children}
    </div>;
};